import firebase from "../../config/firebase";

export const getAds =
  (lastVisible, category, onComplete = () => {}) =>
  async (dispatch) => {
    let ads = firebase.firestore().collection("vendor_bids");
    if (category !== "All") {
      ads = ads.where("category", "==", category);
    }
    ads = ads.where("status", "==", "active").limit(5);
    if (lastVisible) {
      ads = ads.startAfter(lastVisible);
    }
    ads.get().then(async (query) => {
      let ads_data = [];
      let newLastVisible = null;

      for await (let doc of query.docs) {
        ads_data.push({ ...doc.data(), id: doc.id });
      }

      if (!query.empty) {
        newLastVisible = query.docs[query.docs.length - 1];
      }
      if (lastVisible) {
        dispatch({
          type: "GET_ADS_LOAD_MORE",
          payload: {
            ads: ads_data,
            lastVisible: newLastVisible,
            hasMoreDocument: ads_data.length >= 5,
          },
        });
      } else {
        dispatch({
          type: "GET_ADS",
          payload: {
            ads: ads_data,
            lastVisible: newLastVisible,
            hasMoreDocument: ads_data.length >= 5,
          },
        });
      }

      onComplete();
    });
  };

export const getCategories =
  (onComplete = () => {}) =>
  async (dispatch) => {
    let ads = await firebase.firestore().collection("vendor_bids");
    ads.get().then(async (query) => {
      let ads_data = [];
      for await (let doc of query.docs) {
        ads_data.push({ ...doc.data(), id: doc.id });
      }
      const categories = [...new Set(ads_data.map((ad) => ad.category))];
      dispatch({
        type: "GET_ADS_CATEGORIES",
        payload: {
          categories,
        },
      });
      onComplete();
    });
  };

export const addAdsViews = (id, userData) => async () => {
  const userViewRef = firebase
    .firestore()
    .collection("vendor_bids")
    .doc(id)
    .collection("views")
    .doc(userData.fan_id);

  const userViewDoc = await userViewRef.get();

  if (!userViewDoc.exists) {
    await firebase
      .firestore()
      .collection("vendor_bids")
      .doc(id)
      .update({
        total_views: firebase.firestore.FieldValue.increment(1),
      });

    await userViewRef.set({
      ...userData,
      viewed_at: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }
};
